import { Injectable } from '@angular/core';

import { GTMIdentifierTypes } from '@utilities/enums/gtm-identifiers.enum';

@Injectable({
  providedIn: 'root',
})
export class DataLayerEventsService {
  constructor() {}

  submitGtmEvent(type: GTMIdentifierTypes): void {
    const gtmTag = {
      event: type,
    };

    this.pushToDataLayer(gtmTag);
  }

  pushToDataLayer(data: any): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    // Push data to the global data layer array
    (window as any).dataLayer.push(data);
  }
}
